export enum Stage {
  EarlyYear = 1,
  Primary = 2,
  Secondary = 3,
}
